import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import {
  CurrentUser,
  TestSessionDto,
  TestSessionStatusDto,
  TestSessionTypeDto,
  UserDto,
} from "../../autogenerated/models";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Space, Table } from "antd";

interface UserSessionTableProps {
  user: UserDto;
  currentUser: CurrentUser;
}

const UserSessionTable: React.FC<UserSessionTableProps> = ({
  user = {},
  currentUser = {},
}) => {
  const history = useHistory();

  const showTestSessionSummary = useCallback(
    (sessionId) => history.push("/sessionSummary/" + sessionId),
    [history]
  );

  let statuses = user.testSessions
    ?.map((s) => s?.status?.name)
    .filter((v, i, a) => a.indexOf(v) === i)
    .map((s) => {
      return { text: s, value: s ?? "" };
    });

  let sessionTypes = user.testSessions
    ?.map((s) => s?.testSessionType?.name)
    .filter((v, i, a) => a.indexOf(v) === i)
    .map((s) => {
      return { text: s, value: s ?? "" };
    });

  const columns = [
    {
      title: "#",
      key: "#",
      render: (session: TestSessionDto) => (
        <>
          {session.status?.short === "assist" ||
          (session.status?.short === "reviewed" &&
            currentUser?.id !== session.reviewedById) ||
          session.status?.short === "verified" ||
          session.status?.short === "sent" ||
          session.status?.short === "success" ? (
            <ExclamationCircleOutlined />
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      title: "Session name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "statusName",
      render: (status: TestSessionStatusDto) => <> {status?.name} </>,
      filters: statuses,
      onFilter: (value: any, record: TestSessionDto) =>
        record.status?.name?.indexOf(value) === 0,
    },
    {
      title: "Type",
      dataIndex: "testSessionType",
      key: "testSessionType",
      render: (sessionType: TestSessionTypeDto) => <> {sessionType?.name} </>,
      filters: sessionTypes,
      onFilter: (value: any, record: TestSessionDto) =>
        record.testSessionType?.name?.indexOf(value) === 0,
    },
    {
      title: "Actions",
      key: "actions",
      render: (text: string, session: TestSessionDto) => (
        <Space size="middle">
          <Button onClick={() => showTestSessionSummary(session.id)}>
            Summary
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Table
      rowKey={(s) => s.id ?? ""}
      columns={columns}
      dataSource={user.testSessions}
      pagination={false}
      size="small"
    />
  );
};

export default UserSessionTable;
